import { css } from '@styled-system/css';
import { circle, stack } from '@styled-system/patterns';
import type { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

import { DotsIcon } from '@/shared/components/ui/DotsIcon';
import { Separator } from '@/shared/components/ui/Separator';

import 'react-loading-skeleton/dist/skeleton.css';

export const AnalysisMenuItemSkeleton: FC = () => {
  const containerStyles = stack({
    direction: 'column',
    w: '100%',
    gap: 0,
  });

  const cardStyles = stack({
    direction: 'row',
    h: '3.25rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    w: '100%',
    pr: '0.81rem',
    borderRadius: 'sm',
    bg: 'transparent',
    _hover: {
      bg: 'bg.selected',
    },
  });

  const contentStyles = stack({
    direction: 'row',
    alignItems: 'center',
    gap: '0.4rem',
    px: '0.1875rem',
  });

  const imageSkeletonStyles = circle({
    w: '1.875rem',
    h: '1.875rem',
    flexShrink: 0,
    overflow: 'hidden',
    bg: 'bg.selected',
  });

  const infoStyles = stack({
    direction: 'column',
    alignItems: 'flex-start',
    gap: '0.2rem',
  });

  const separatorStyles = css({
    alignSelf: 'center',
    w: 'calc(100% - 1rem)',
    mt: '-1px',
  });

  return (
    <div className={containerStyles}>
      <div className={cardStyles}>
        <div className={contentStyles}>
          {/* Image skeleton */}
          <div className={imageSkeletonStyles}>
            <Skeleton height="100%" width="100%" circle style={{ display: 'block' }} />
          </div>

          {/* Info skeleton */}
          <div className={infoStyles}>
            {/* Name skeleton */}
            <div className={css({ display: 'flex', alignItems: 'center', h: '0.7rem' })}>
              <Skeleton width="8rem" height="0.7rem" />
            </div>
            {/* Status skeleton */}
            <div className={css({ display: 'flex', alignItems: 'center', h: '0.5rem' })}>
              <Skeleton width="7rem" height="0.5rem" />
            </div>
          </div>
        </div>

        {/* Menu skeleton - DotsIcon */}
        <DotsIcon
          variant="horizontal"
          className={css({ w: '0.82rem', h: '0.82rem', color: 'font.lowkey', opacity: 0.3 })}
        />
      </div>

      <Separator orientation="horizontal" className={separatorStyles} />
    </div>
  );
};
